import { GET_CAREGIVERS, GET_CAREGIVERS_DONE, GET_CAREGIVERS_ERROR, RESET_CAREGIVERS } from './actionTypes';
export const getCaregivers = () => ({ type: GET_CAREGIVERS });
export const getCaregiversDone = (data) => ({
    type: GET_CAREGIVERS_DONE,
    data
});
export const getCaregiversError = (errorMessage) => ({
    type: GET_CAREGIVERS_ERROR,
    errorMessage
});
export const resetCaregivers = () => ({ type: RESET_CAREGIVERS });
//# sourceMappingURL=actionCreators.js.map